import { render } from "./DialogOptionV2Module.vue?vue&type=template&id=047085d4&scoped=true"
import script from "./DialogOptionV2Module.vue?vue&type=script&lang=js"
export * from "./DialogOptionV2Module.vue?vue&type=script&lang=js"

import "./DialogOptionV2Module.vue?vue&type=style&index=0&id=047085d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047085d4"]])

export default __exports__